module.exports = __webpack_public_path__ + "static/media/fl_17.a9152815.png";